import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getCategoryHeirarchy } from '../../../redux/getCategoryHeirarchy';
import NestedUserHeader from '../../../component/reusable/NestedUserHeader';
import AddVendorForm from '../../../component/allvendor/AddVendorForm';
import { getAllAdminThunk } from '../../../redux/admin/adminSlice';
import { exportManufacturerThunk } from '../../../redux/manufacturer/getAllManufacturerSlice';

const AddVendor = () => {

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllAdminThunk())
    dispatch(exportManufacturerThunk())
  }, []);

  return (
    <div >
      <NestedUserHeader 
        index="Add Vendor"
        root="Dashboard"
        buttonText={'Back to list'}/>
      <AddVendorForm />
    </div>
  );

};

export default AddVendor;
